/* unplugin-vue-components disabled */import { render } from "./CDateHeader.vue?vue&type=template&id=66051dfc&scoped=true&ts=true"
import script from "./CDateHeader.vue?vue&type=script&lang=ts"
export * from "./CDateHeader.vue?vue&type=script&lang=ts"

import "./CDateHeader.vue?vue&type=style&index=0&id=66051dfc&lang=less&scoped=true"
import "./CDateHeader.vue?vue&type=style&index=1&id=66051dfc&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66051dfc"]])

export default __exports__